import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {useLocation, useNavigate} from "react-router-dom";
import {device} from "../../assets/styles/media";

const List = styled.ul`
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    gap: 14px;
    margin-top: 60px;
    font-weight: 500;

    ${device.tablet} {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
    }
    ${device.mobile} {
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
        gap: 7px;
    }
`;
const Item = styled.li`
    border: 1px solid #e5e5e5;
    border-radius: 20px;
    padding: 6px 20px 6px;
    color: ${({$active}) => ($active ? "#fff" : "#414141")};
    background-color: ${({$active}) => ($active ? "#5233d0" : "#fff")};
    font-size: 16px;
    cursor: pointer;

    &:hover {
        background-color: #5233d0;
        color: #fff;
    }
    ${device.tablet} {
        padding: 10px 20px;
    }
    ${device.mobile} {
        font-size: 13px;
        font-weight: 500;
        padding: 7px 15px;
        margin-bottom: 5px;
    }
    
`;
const LinkItem = styled.a`
    display: inline-block;
    border: 1px solid #e5e5e5;
    border-radius: 20px;
    padding: 6px 20px 6px;
    font-size: 16px;
    cursor: pointer;
    color: ${({$active}) => ($active ? "#fff" : "#414141")};
    background-color: ${({$active}) => ($active ? "#5233d0" : "#fff")};

    ${device.tablet} {
        padding: 10px 23px;
        font-size: 17px;
    }

    ${device.mobile} {
        font-size: 13px;
        padding: 7px 15px;
        margin-bottom: 5px;
    }
`;
const SubNav = ({list, link}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [active, setActive] = useState(0);
    const [path, setPath] = useState("");

    useEffect(() => {
        if(location.pathname.includes("/program") || location.pathname.includes("/notice")){
            const pathParts = location.pathname.split("/"); // ['', 'program', 'permanent', '1']
            let basePath ;
            if(pathParts.length  >= 4 && location.pathname.includes("museum")){
                basePath = `/${pathParts[1]}/${pathParts[2]}/${pathParts[3]}`;
            }else{
                basePath = `/${pathParts[1]}/${pathParts[2]}`;
            }
            setPath(basePath)
        }else{
            setPath(location.pathname)
        }
    }, [location])

    return (
        <List>
            {list.map((el, index) => {
                const isActive = link ? active === index : el.link === path;
                return link ? (
                    <LinkItem
                        key={index}
                        href={el.link}
                        $active={isActive}
                        onClick={el.open ? el.open : () => setActive(index)}
                    >
                        {el.name}
                    </LinkItem>
                ) : (
                    <Item
                        key={index}
                        $active={isActive}
                        onClick={() => navigate(el.link)}
                    >
                        {el.name}
                    </Item>
                );
            })}
        </List>
    )
        ;
};

export default SubNav;
